/** =========================================================
 * Project part types controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-project-part-types')
    .controller('ProjectPartTypesController', ProjectPartTypesController);

  ProjectPartTypesController.$inject = ['$rootScope', '$scope', '$api', '$state', '$stateParams', '$translate'];

  function ProjectPartTypesController($rootScope, $scope, $api, $state, $stateParams, $translate) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;

      Raven.captureBreadcrumb({
        message: 'Page project part types',
        data: {
          filters: $stateParams.filters
        }
      });

      vm.tableConfig = {
        model: 'project_part_type',
        getDataParams: {
          order: {
            id: 'desc'
          },
          count: ['project_parts']
        },
        filters: angular.copy($stateParams.filters),
        fields: [{
          title: 'Sort order',
          key: 'order',
          order: true
        }, {
          title: 'Title',
          key: 'name',
          order: true
        }],
        add: {
          template: 'app/views/dialogs/item-project-part-type.html'
        },
        edit: {
          template: 'app/views/dialogs/item-project-part-type.html',
          except: ['project_parts_count']
        },
        delete: {},
        linkButtons: [{
          title: 'Project parts',
          icon: 'icon-layers',
          class: 'btn-info',
          permission: $rootScope.helpers.hasPermissionTo('project_part view'),
          action: function (item) {
            try {
              $state.go('app.page-project-parts', {
                filters: [{
                  name: $translate.instant('Project part type') + ': ' + item.name,
                  attr: 'where',
                  value: [
                    ['project_part_type_id', '=', item.id]
                  ]
                }]
              });
            } catch (error) {
              Raven.captureException(error);
            }
          },
          text: function (item) {
            try {
              return item.project_parts_count;
            } catch (error) {
              Raven.captureException(error);
            }

            return '';
          }
        }]
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
